(() => {
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (scope = document) => {
    const sections = scope.matches?.('[data-brand-principles]')
      ? [scope]
      : scope.querySelectorAll('[data-brand-principles]');

    sections.forEach((section) => {
      if (initialized.has(section)) return;
      const track = section.querySelector('[data-brand-principles-track]');
      const cards = [...section.querySelectorAll('[data-brand-principles-card]')];
      const previous = section.querySelector('[data-brand-principles-step="-1"]');
      const next = section.querySelector('[data-brand-principles-step="1"]');
      if (!track || cards.length < 2 || !previous || !next) return;
      initialized.add(section);

      let frame = 0;
      const activeIndex = () => cards.reduce((closest, card, index) => {
        const first = Math.abs(cards[closest].offsetLeft - track.scrollLeft);
        const candidate = Math.abs(card.offsetLeft - track.scrollLeft);
        return candidate < first ? index : closest;
      }, 0);

      const updateControls = () => {
        frame = 0;
        const index = activeIndex();
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };

      const scheduleUpdate = () => {
        if (!frame) frame = window.requestAnimationFrame(updateControls);
      };

      const showCard = (index) => {
        const target = cards[Math.max(0, Math.min(cards.length - 1, index))];
        track.scrollTo({
          left: target.offsetLeft - cards[0].offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      section.addEventListener('click', (event) => {
        const button = event.target.closest('[data-brand-principles-step]');
        if (!button || !section.contains(button)) return;
        showCard(activeIndex() + Number(button.dataset.brandPrinciplesStep));
      });

      track.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = activeIndex();
        showCard(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      updateControls();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
